import React, { useEffect, useRef, useState } from 'react';
import { IoCalendarSharp } from 'react-icons/io5';
import { formatRangeDate, monthRange } from './dateRange';

export default function DateRangePicker({ range, setRange, label = 'Select date range', title }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(range);
  const root = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const escape = event => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', close);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', close); document.removeEventListener('keydown', escape); };
  }, [open]);
  const invalid = !draft.startDate || !draft.endDate || draft.startDate > draft.endDate;
  return <div className="relative" ref={root}>
    <button type="button" aria-label={label} aria-expanded={open} onClick={() => { setDraft(range); setOpen(!open); }} title={title}
      className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:bg-slate-50">
      <IoCalendarSharp /><span>{formatRangeDate(range.startDate)} – {formatRangeDate(range.endDate)}</span>
    </button>
    {open && <form aria-label={label} onSubmit={event => { event.preventDefault(); if (!invalid) { setRange(draft); setOpen(false); } }}
      className="absolute right-0 top-full z-30 mt-2 w-72 rounded-xl border border-slate-200 bg-white p-4 shadow-lg space-y-3">
      <label className="block text-xs font-semibold text-slate-600">From
        <input aria-label="Start date" type="date" required value={draft.startDate} max={draft.endDate || undefined} onChange={event => setDraft({ ...draft, startDate: event.target.value })} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm" />
      </label>
      <label className="block text-xs font-semibold text-slate-600">To
        <input aria-label="End date" type="date" required value={draft.endDate} min={draft.startDate || undefined} onChange={event => setDraft({ ...draft, endDate: event.target.value })} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm" />
      </label>
      {invalid && <p role="alert" className="text-xs text-red-500">Choose a valid start and end date.</p>}
      <div className="flex items-center justify-between gap-2">
        <button type="button" onClick={() => setDraft(monthRange())} className="text-xs font-semibold text-blue-600">Last month</button>
        <button type="submit" disabled={invalid} className="rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold text-white disabled:opacity-50">Apply</button>
      </div>
    </form>}
  </div>;
}
